import { base, mainnet, sepolia } from "viem/chains";

const CURRENCY_SYMBOL = { ETH: "ETH" };

export const hardhat = {
    id: 1337,
    name: "Hardhat",
    network: "hardhat",
    nativeCurrency: {
        decimals: 18,
        name: "Ethereum",
        symbol: CURRENCY_SYMBOL.ETH,
    },
    rpcUrls: {
        public: { http: ["http://localhost:8545"] },
        default: { http: ["http://localhost:8545"] },
    },
    blockExplorers: {
        default: {
            url: "http://localhost:4000",
        },
    },
    contracts: {},
};

export const privatenet = {
    id: 8888,
    name: "Private",
    network: "private",
    nativeCurrency: {
        decimals: 18,
        name: "Ethereum",
        symbol: CURRENCY_SYMBOL.ETH,
    },
    rpcUrls: {
        public: {
            http: ["https://anvil.soon.murmurprotocol.com"],
        },
        default: {
            http: ["https://anvil.soon.murmurprotocol.com"],
        },
    },
    blockExplorers: {
        default: {
            url: "https://anvil-blockscout.soon.murmurprotocol.com",
        },
    },
    contracts: {},
};

export const baseSepolia = {
    id: 84532,
    name: "Base Sepolia",
    network: "baseSepolia",
    nativeCurrency: {
        decimals: 18,
        name: "Ethereum",
        symbol: CURRENCY_SYMBOL.ETH,
    },
    rpcUrls: {
        public: {
            http: [
                "https://base-sepolia.g.alchemy.com/v2/PQ4kCacRvUa9l3N-1i4DskAe-FH_VZUI",
            ],
        },
        dev: {
            http: ["https://sepolia.base.org"],
        },
        default: {
            http: [
                "https://base-sepolia.g.alchemy.com/v2/PQ4kCacRvUa9l3N-1i4DskAe-FH_VZUI",
            ],
        },
    },
    contracts: {},
};

export function getChainByStringID(id) {
    switch (id) {
        case "1337":
            return hardhat;
        case "8888":
            return privatenet;
        case "84532":
            return baseSepolia;
        case "11155111":
            sepolia.name = "Ethereum Sepolia";
            return sepolia;
        case "8453":
            return {
                ...base,
                rpcUrls: {
                    public: {
                        http: [
                            "https://base-mainnet.g.alchemy.com/v2/mc3Z-MTKmfTvu103mcSsa9sNbhG-wn8s",
                        ],
                    },
                    default: {
                        http: [
                            "https://base-mainnet.g.alchemy.com/v2/mc3Z-MTKmfTvu103mcSsa9sNbhG-wn8s",
                        ],
                    },
                },
            };
        case "1":
            return mainnet;
        default:
            return null;
    }
}

export function getEnvDependentChain() {
    return getChainByStringID(import.meta.env.VITE_CHAIN_ID);
}

export const getExtraEnvChains = () => {
    const extraChains = [];

    const chain = getEnvDependentChain();
    if (chain !== base) {
        extraChains.push(chain);
    }

    return extraChains;
};

export function getDefaultChains() {
    const defaultChains = [getEnvDependentChain()];

    return defaultChains;
}
